import qs from 'qs';
import { CreateEventDTO, EventResponseDTO, EventsFiltersDTO } from '../app/pages/calendar/dto';
import { baseApi } from './_baseQuery';


export const recallsApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        findAllRecalls: build.query<EventResponseDTO, EventsFiltersDTO>({
            query: (filters) => ({
                url: "/events",
                params: qs.stringify(filters, {
                    arrayFormat: "repeat",
                    encode: true,
                })
            }),
            providesTags: (_, __, data) => [{ type: 'Recalls', id: data.contactId }]
        }),
        createRecall: build.mutation<void, CreateEventDTO>({
            query: (body) => ({
                url: "/events",
                method: "POST",
                body
            }),
            invalidatesTags: (_, __, data) => [{ type: 'Recalls', id: data.contactId }]
        }),
        updateEvent: build.mutation<void, { id: string; request: CreateEventDTO, contactId: string }>({
            async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
                const { id, request } = arg;
                const updateRes = await fetchWithBQ({
                    url: `/events/${id}`,
                    method: 'PUT',
                    body: {
                        notes: request.notes
                    },
                });
                if (updateRes.error) {
                    return { error: updateRes.error };
                }
                const rescheduleRes = await fetchWithBQ({
                    url: `/events/${id}/reschedule`,
                    method: 'PUT',
                    body: {
                        startDate: request.startDate,
                        endDate: request.endDate,
                        notification: request.notification
                    },
                });
                if (rescheduleRes.error) {
                    return { error: rescheduleRes.error };
                }

                return { data: undefined };
            },
            invalidatesTags: (_result, _error, { contactId }) => [{ type: 'Recalls', id: contactId }],
        }),
        // rescheduleEvents: build.mutation<void, { id: string, startDate: string, endDate: string, notification: number, contactId: string }>({
        //     query: ({ id, startDate, endDate, notification }) => ({
        //         url: `/events/${id}/reschedule`,
        //         method: 'POST',
        //         body: {
        //             startDate,
        //             endDate,
        //             notification
        //         }
        //     }),
        //     invalidatesTags: (_result, _error, { contactId }) => [{ type: 'Recalls', id: contactId }],
        // }),
        deleteRecall: build.mutation<void, { id: string, contactId: string }>({
            query: ({ id }) => ({
                url: `/events/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_result, _error, { contactId }) => [{ type: 'Recalls', id: contactId }],
        }),
    }),
});

export const {
    useCreateRecallMutation,
    useFindAllRecallsQuery,
    useDeleteRecallMutation,
    useUpdateEventMutation,
} = recallsApi